import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button, Container } from '@mui/material';
import { Header } from 'components/Header';
import { observer } from 'mobx-react-lite';

type CenteredFormPageProps = {
  onBack?: () => void;
  belowHeader?: any;
  children?: JSX.Element;
};

const CenteredFormPage = observer(({ onBack, belowHeader, children, ...other }: CenteredFormPageProps) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }} {...other}>
      <Header />
      {belowHeader}
      <div
        style={{
          flex: 1,
          display: 'flex',
          position: 'relative',
        }}
      >
        {onBack && (
          <div aria-label="sidebar" style={{ position: 'absolute' }}>
            <Button sx={{ margin: '30px' }} onClick={() => onBack()} variant="text" startIcon={<ArrowBack />}>
              Back
            </Button>
          </div>
        )}
        <Container
          maxWidth="xs"
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          {children}
        </Container>
      </div>
    </div>
  );
});

export { CenteredFormPage };
